var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastagRecharge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43 11.32H3.57c-.93 0-1.84-.31-2.57-.87",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.08 6c1.1-.84 2.46-1.35 3.95-1.38 3.74-.09 6.84 2.83 6.93 6.54.09 3.71-2.86 6.78-6.6 6.87-3.74.09-6.84-2.83-6.93-6.54-.02-.93.14-1.81.47-2.62M1 1h7.83c.92 0 1.8.36 2.45 1l2.66 2.61",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44 4.37l2.88 2.85c.7.69.7 1.82 0 2.51-.7.69-1.84.69-2.54 0L6.84 7.81c-.57.55-1.35.88-2.21.88-.86 0-1.65-.34-2.22-.9M14.69 8.19c.77.45 1.03 1.43.58 2.2-.45.77-1.43 1.03-2.2.58l.35 3.7M13.07 10.97l2.7 1.57M13.82 7.68l3.89 2.26",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFastagRecharge;